import React, { useEffect, useState } from 'react';
import { WithWizard } from 'react-albus-react18';
import CustomTitle from '../../components/UI/title/CustomTitle';
import MyButton from '../../components/UI/button/MyButton';
import MyInput from '../../components/UI/input/MyInput';
import zIndex from '@mui/material/styles/zIndex';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { useDispatch, useSelector } from 'react-redux';
import { useFetchBusinessProfilesQuery, useUpdateBusinessProfileMutation } from '../../api/dataApi';
import { useFetchPicturesQuery } from '../../api/unsplashApi';
import useMixpanel from '../../hooks/useMixpanel';
import { setAdjustedName, setIndustry } from '../../store/scrappingSlice';


const BusinessAreaNew = ({ save, setButtonShow, bName, setBlockPaddingBottom, setButtonStatus, setAiShow, setEventProperties, sessionId, setEventName, setWhiteWrapper, setWelcometo }) => {

    useEffect(() => {
        setWhiteWrapper(true)
        setWelcometo(false)
    }, [])

    const dispatch = useDispatch();

    const { trackEvent } = useMixpanel();

    const [error, setError] = useState(false);

    const [selectedOption, setSelectedOption] = useState(null);
    useEffect(() => {
        console.log(selectedOption)
    }, [selectedOption])

    const { industry } = useSelector((state) => state.scrapping);

    const history = useHistory();
    const [isButtonDisabled, setIsButtonDisabled] = useState(true);

    const handleInputChange = (value) => {
        setSelectedOption(value)
        setIsButtonDisabled(false);
    };

    const { data: businessProfiles, isLoading: isLoadingProfiles, refetch } = useFetchBusinessProfilesQuery();
    const [updateProfile, { isLoading: updating, error: updateError }] = useUpdateBusinessProfileMutation();

    const { data: picturesData, error: fetchError } = useFetchPicturesQuery({ selectedOption });

    const handleUpdateProfile = async (industryValue) => {
        try {
            const profileId = businessProfiles?.data?.id;
            console.log(businessProfiles?.data?.id)
            const data = {
                // ...businessProfiles?.data,
                businessArea: industryValue,
            }
            if (profileId) {
                await updateProfile({ id: profileId, data }).unwrap();
                console.log('Profile updated successfully');
            } else {
                console.error('Profile ID not found');
            }
        } catch (err) {
            console.error('Error updating profile:', err);
        }
    };

    useEffect(() => {
        if (setButtonShow) {
            setButtonShow(true)
        }
        if (setBlockPaddingBottom) {
            setBlockPaddingBottom('32rem')
        }
        if (setButtonStatus) {
            setButtonStatus('')
        }
        if (setAiShow) {
            setAiShow(false)
        }
        if (setSelectedOption) {
            setSelectedOption(null)
        }

        const setVHVariable = () => {
            const vh = window.innerHeight * 0.01;
            document.documentElement.style.setProperty('--vh', `${vh}px`);
        };
        setVHVariable();
        window.addEventListener('resize', setVHVariable);
        return () => window.removeEventListener('resize', setVHVariable);

    }, []);

    const updateProfileAndRefetch = async () => {
        if (selectedOption) {
            await handleUpdateProfile(selectedOption);
            refetch();
        }
    };

    return (
        <div className='page--without-button page'>

            <div className="page-content">
                <CustomTitle style={{ marginBottom: "24rem", zIndex: '1', position: 'relative' }} title="Choose your industry" />

                <MyInput save={save} industry={industry} bName={bName} setEventName={setEventName} setEventProperties={setEventProperties} sessionId={sessionId} error={error} setSelectedOption={setSelectedOption} onChange={handleInputChange} placeholder='Search industries'></MyInput>


                <MyButton style={{ zIndex: 1, position: 'relative' }}
                    buttonIcon={'no'}
                    buttonText={`${save ? 'Save' : 'Continue'}`}
                    className={`${error ? 'error' : ''}`}
                    onClick={() => {
                        if (isButtonDisabled) {
                            setError(true)
                            setTimeout(() => {
                                setError(false)
                            }, 500);
                            return
                        }
                        if (save) {
                            dispatch(setIndustry(selectedOption));
                            dispatch(setAdjustedName(true));

                            const params = new URLSearchParams(window.location.search);
                            history.push({
                                pathname: '/product-check',
                                search: `?${params.toString()}`,
                            });
                        } else {
                            trackEvent('onboarding_industry', {
                                productlink_added: 'MANUAL',
                                industry: selectedOption,
                            }, true

                            );
                            localStorage.setItem('industry', selectedOption)
                            updateProfileAndRefetch()
                            const params = new URLSearchParams(window.location.search);
                            history.push({
                                pathname: '/company-name',
                                search: `?${params.toString()}`,
                            });



                        }
                    }}
                >
                    {/* <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10.8901 3.54917C10.6197 3.81575 10.5944 4.23698 10.816 4.53253L10.8826 4.60981L15.4583 9.24992L3.75 9.24992C3.33579 9.24992 3 9.5857 3 9.99992C3 10.3823 3.28611 10.6978 3.65592 10.7441L3.75 10.7499H15.4583L10.8826 15.39C10.616 15.6604 10.5966 16.082 10.8224 16.3743L10.8901 16.4507C11.1605 16.7172 11.582 16.7366 11.8744 16.5108L11.9507 16.4431L17.7841 10.5265C18.048 10.2588 18.07 9.84232 17.8501 9.54985L17.7841 9.47336L11.9507 3.5567C11.6599 3.26173 11.1851 3.25837 10.8901 3.54917Z" fill="#5BF0A5" />
    </svg> */}
                </MyButton>
            </div>



        </div>
    );
}

export default BusinessAreaNew;
